import React from "react";

const HierarchyContext = React.createContext({});

export default HierarchyContext;
